<script lang="ts">
export default { name: 'LayoutWrapper', inheritAttrs: false }
</script>

<script lang="ts" setup>
import { reactive, provide } from 'vue'
import { LayoutData, LayoutDataKey } from './use-layout-data'

const layout = reactive<LayoutData>({
  header: { height: 0, offset: 0 },
  footer: { height: 0, offset: 0 },
  float: { bottom: { height: 0 } },
})

provide(LayoutDataKey, layout)
</script>

<template>
  <div class="relative min-h-full">
    <slot></slot>
  </div>
</template>
